// import React, { useState, useEffect } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   IconButton,
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   Box,
//   Container,
//   Typography,
//   Divider
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import { Link, useLocation } from "react-router-dom";
// import Logo from "../../../Assets/logo.png";

// const navLinks = [
//   { label: "Home", path: "/" },
//   { label: "About", path: "/about" },
//   { label: "Services", path: "/services" },
//   { label: "Contact", path: "/contact" }
// ];

// const WebNavBar = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   const toggleDrawer = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 15);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const isActive = (path) => location.pathname === path;

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{
//           backdropFilter: "blur(10px)",
//           background: scrolled ? "rgba(255,255,255,0.9)" : "#fff",
//           transition: "all 0.3s ease",
//           borderBottom: scrolled ? "1px solid #eee" : "none"
//         }}
//       >
//         <Container maxWidth="lg">
//           <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>

//             {/* Logo */}
//             <Box
//               component={Link}
//               to="/"
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 textDecoration: "none"
//               }}
//             >
//               <Box
//                 component="img"
//                 src={Logo}
//                 alt="Rite Marketing Automation Tool"
//                 sx={{
//                   height: 60,
//                   width: "auto",
//                   transition: "0.3s"
//                 }}
//               />
//             </Box>

//             {/* Desktop Menu */}
//             <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3, alignItems: "center" }}>

//               {navLinks.map((link) => (
//                 <Button
//                   key={link.path}
//                   component={Link}
//                   to={link.path}
//                   sx={{
//                     color: "#333",
//                     fontWeight: 600,
//                     textTransform: "none",
//                     fontSize: "15px",
//                     position: "relative",
//                     "&:hover": {
//                       color: "#094C9F",
//                       background: "transparent"
//                     },
//                     "&::after": {
//                       content: '""',
//                       position: "absolute",
//                       width: isActive(link.path) ? "100%" : "0%",
//                       height: "2px",
//                       bottom: -4,
//                       left: 0,
//                       background: "#094C9F",
//                       transition: "0.3s"
//                     },
//                     "&:hover::after": {
//                       width: "100%"
//                     }
//                   }}
//                 >
//                   {link.label}
//                 </Button>
//               ))}

//               {/* Client Login */}
//               <Button
//                 component={Link}
//                 to="/client-login"
//                 variant="outlined"
//                 sx={{
//                   borderColor: "#094C9F",
//                   color: "#094C9F",
//                   textTransform: "none",
//                   fontWeight: 600,
//                   px: 3,
//                   borderRadius: "8px",
//                   "&:hover": {
//                     background: "#094C9F",
//                     color: "#fff",
//                     borderColor: "#094C9F"
//                   }
//                 }}
//               >
//                 Client Login
//               </Button>

//               {/* Admin Login */}
//               <Button
//                 component={Link}
//                 to="/login"
//                 variant="contained"
//                 sx={{
//                   background: "linear-gradient(135deg,#094C9F,#1976d2)",
//                   textTransform: "none",
//                   fontWeight: 600,
//                   px: 3,
//                   borderRadius: "8px",
//                   boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
//                   "&:hover": {
//                     background: "linear-gradient(135deg,#083a78,#1565c0)"
//                   }
//                 }}
//               >
//                 Login
//               </Button>

//             </Box>

//             {/* Mobile Button */}
//             <IconButton
//               onClick={toggleDrawer}
//               sx={{ display: { md: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>

//           </Toolbar>
//         </Container>
//       </AppBar>

//       {/* Mobile Drawer */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={toggleDrawer}
//         PaperProps={{
//           sx: { width: 260 }
//         }}
//       >
//         <Box sx={{ p: 2, display: "flex", justifyContent: "space-between" }}>
//           <Typography variant="h6" fontWeight={600}>
//             Menu
//           </Typography>

//           <IconButton onClick={toggleDrawer}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Divider />

//         <List>
//           {navLinks.map((link) => (
//             <ListItem key={link.path} disablePadding>
//               <ListItemButton
//                 component={Link}
//                 to={link.path}
//                 onClick={toggleDrawer}
//                 selected={isActive(link.path)}
//               >
//                 <ListItemText primary={link.label} />
//               </ListItemButton>
//             </ListItem>
//           ))}

//           {/* Client Login */}
//           <ListItem sx={{ mt: 2 }}>
//             <Button
//               fullWidth
//               component={Link}
//               to="/client-login"
//               variant="outlined"
//               onClick={toggleDrawer}
//               sx={{
//                 borderColor: "#094C9F",
//                 color: "#094C9F",
//                 textTransform: "none",
//                 fontWeight: 600
//               }}
//             >
//               Client Login
//             </Button>
//           </ListItem>

//           {/* Admin Login */}
//           <ListItem>
//             <Button
//               fullWidth
//               component={Link}
//               to="/login"
//               variant="contained"
//               onClick={toggleDrawer}
//               sx={{
//                 background: "linear-gradient(135deg,#094C9F,#1976d2)",
//                 textTransform: "none",
//                 fontWeight: 600
//               }}
//             >
//               Login
//             </Button>
//           </ListItem>

//         </List>
//       </Drawer>
//     </>
//   );
// };

// export default WebNavBar;


import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Container,
  Typography,
  Divider,
  Stack,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../Assets/logo.png";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];

const WebNavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleDrawer = () => setMobileOpen(!mobileOpen);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 15);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backdropFilter: "blur(12px)",
          background: scrolled ? "rgba(255,255,255,0.95)" : "#fff",
          transition: "all 0.3s ease",
          borderBottom: scrolled ? "1px solid #e0e0e0" : "1px solid transparent",
          boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.06)" : "none",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between", py: 0.5 }}>
            {/* Logo */}
            <Box
              component={Link}
              to="/"
              sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}
            >
              <Box
                component="img"
                src={Logo}
                alt="Rite Marketing Automation Tool"
                sx={{
                  height: { xs: 40, md: 52 },
                  width: "auto",
                  transition: "0.3s",
                }}
              />
            </Box>

            {/* Desktop Menu */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1, alignItems: "center" }}>
              {navLinks.map((link) => (
                <Button
                  key={link.path}
                  component={Link}
                  to={link.path}
                  sx={{
                    color: isActive(link.path) ? accent : "#555",
                    fontWeight: isActive(link.path) ? 700 : 500,
                    textTransform: "none",
                    fontSize: "0.9rem",
                    px: 2,
                    position: "relative",
                    "&:hover": { color: accent, background: "transparent" },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      width: isActive(link.path) ? "60%" : "0%",
                      height: "2.5px",
                      bottom: 4,
                      left: "50%",
                      transform: "translateX(-50%)",
                      background: accent,
                      borderRadius: "2px",
                      transition: "0.3s",
                    },
                    "&:hover::after": { width: "60%" },
                  }}
                >
                  {link.label}
                </Button>
              ))}

              {/* Client Signup */}
              <Button
                component={Link}
                to="/client-signup"
                variant="outlined"
                sx={{
                  ml: 2,
                  borderColor: accent,
                  color: accent,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  px: 2.5,
                  borderRadius: "8px",
                  "&:hover": {
                    background: accentLight,
                    borderColor: accent,
                  },
                }}
              >
                Sign Up
              </Button>

              {/* Client Login */}
              <Button
                component={Link}
                to="/client-login"
                variant="contained"
                disableElevation
                sx={{
                  background: accent,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  px: 2.5,
                  borderRadius: "8px",
                  boxShadow: "0 4px 14px rgba(13,71,161,0.25)",
                  "&:hover": {
                    background: "#0a3a85",
                    boxShadow: "0 6px 20px rgba(13,71,161,0.35)",
                  },
                }}
              >
                Client Login
              </Button>

              {/* Staff Login - subtle */}
              <Button
                component={Link}
                to="/login"
                sx={{
                  color: "#999",
                  textTransform: "none",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  minWidth: "auto",
                  px: 1.5,
                  "&:hover": { color: accent, background: "transparent" },
                }}
              >
                Staff
              </Button>
            </Box>

            {/* Mobile Menu Icon */}
            <IconButton onClick={toggleDrawer} sx={{ display: { md: "none" }, color: accent }}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={toggleDrawer}
        PaperProps={{ sx: { width: 280 } }}
      >
        <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box component="img" src={Logo} alt="Logo" sx={{ height: 36 }} />
          <IconButton onClick={toggleDrawer}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        <List sx={{ px: 1 }}>
          {navLinks.map((link) => (
            <ListItem key={link.path} disablePadding>
              <ListItemButton
                component={Link}
                to={link.path}
                onClick={toggleDrawer}
                sx={{
                  borderRadius: "8px",
                  my: 0.3,
                  color: isActive(link.path) ? accent : "#555",
                  fontWeight: isActive(link.path) ? 700 : 400,
                  backgroundColor: isActive(link.path) ? accentLight : "transparent",
                  "&:hover": { backgroundColor: accentLight },
                }}
              >
                <ListItemText primary={link.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Stack spacing={1.5} sx={{ px: 2, mt: 2 }}>
          <Button
            fullWidth
            component={Link}
            to="/client-signup"
            variant="outlined"
            onClick={toggleDrawer}
            sx={{
              borderColor: accent,
              color: accent,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              py: 1.2,
              "&:hover": { backgroundColor: accentLight, borderColor: accent },
            }}
          >
            Sign Up
          </Button>

          <Button
            fullWidth
            component={Link}
            to="/client-login"
            variant="contained"
            disableElevation
            onClick={toggleDrawer}
            sx={{
              background: accent,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              py: 1.2,
              "&:hover": { background: "#0a3a85" },
            }}
          >
            Client Login
          </Button>

          <Button
            fullWidth
            component={Link}
            to="/login"
            onClick={toggleDrawer}
            sx={{
              color: "#999",
              textTransform: "none",
              fontSize: "0.8rem",
              "&:hover": { color: accent, background: "transparent" },
            }}
          >
            Staff Login
          </Button>
        </Stack>
      </Drawer>
    </>
  );
};

export default WebNavBar;
